import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGIN_PERMISSION,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  RESET_LOGIN_FLAG,
  GET_IP,
  GET_IP_SUCCESS,
  GET_IP_ERROR,
  LOGIN_USER_INFO,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
};

const login = (state = initialState, action) => {
  // console.log("🚀 ~ file: reducer.js ~ line 16 ~ login ~ action", action);
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_IP:
      state = {
        ...state,
      };
      break;
    case GET_IP_SUCCESS:
      state = {
        ...state,
        data_ip: action.payload,
      };
      break;

    case GET_IP_ERROR:
      state = {
        ...state,
        error_ip: true,
      };
      break;

    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOGIN_PERMISSION:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOGOUT_USER:
      state = { ...state, isUserLogout: false };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload.message,
        status: action.payload.status,
        loading: false,
        isUserLogout: false,
      };
      break;
    case RESET_LOGIN_FLAG:
      state = {
        ...state,
        error: null,
      };
      break;
    case LOGIN_USER_INFO:
      state = {
        ...state,
        userInfo: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
